module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Jb.d9d674b9.png";